const handleResize = () => {
  const mvp = document.getElementById('view-port');
  if (screen.width < 1600) {
    // mvp?.setAttribute('content', 'width=1600');
  } else {
    mvp?.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0');
  }
};

export const stop = () => {
  window.removeEventListener('resize', handleResize);
  const mvp = document.getElementById('view-port');
  mvp?.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0');
};

export const start = () => {
  handleResize();
  window.addEventListener('resize', handleResize);
};
